import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=5eef0ad8"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAlunoPage.vue?vue&type=style&index=0&id=5eef0ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports